<template>
  <section id="tempLogin" class="temp_login_wrap">
    <div class="temp_login_box">
      <h1 class="temp_login_title">임시 로그인</h1>
      <input
        type="text"
        class="temp_login_input"
        placeholder="테스트 사용자 ID"
        v-model="email"
        v-on:keyup.enter="login"
      />
      <input
        type="password"
        class="temp_login_input"
        placeholder="비밀번호를 입력하세요"
        v-model="password"
        v-on:keyup.enter="login"
      />
      <div class="temp_login_error" v-if="error">
        {{ error }}
      </div>
      <button class="temp_login_bt" :disabled="loading" @click="login">
        로그인
      </button>
    </div>
  </section>
</template>
<script>
import Util from '@/util';

export default {
  name: 'TempLogin',
  data() {
    return {
      loading: false,
      error: null,
      email: '',
      password: '',
    };
  },
  async created() {
    // 이미 세션이 있으면 바로 이동
    if (this.$store.state && this.$store.state.token) {
      let result = await Util.hasSession(this);
      if (result) {
        await this.goNextPage();
      }
    }
  },
  methods: {
    async getSettings() {
      await this.$http
        .get('/api/v1/systems')
        .then((response) => {
          this.settings = response.data;
          if (this.settings === '' || this.settings === null) {
            this.settings = Object.assign({}, this.defaultSettings);
          }
          this.$store.dispatch('setSettings', this.settings);
        })
        .catch((error) => {
          this.$store.dispatch('setSettings', this.defaultSettings);
        });
    },
    async goNextPage() {
      const isAdmin = (await this.$http.get('/api/auth/check/admin/server'))
        .data;
      if (isAdmin === true) {
        this.$router.replace('/dashboard');
      } else {
        this.$router.replace('/sMeeting');
      }
    },
    login() {
      this.error = null;

      if (this.email === '' || this.email === null) {
        this.error = '이메일이 입력되지 않았습니다.';
        return;
      }

      if (this.password === '' || this.password === null) {
        this.error = '비밀번호가 입력되지 않았습니다.';
        return;
      }

      this.loading = true;

      // 임시 로그인 화면이기 때문에 crypto-js 생략하고 그냥 email / password 넘김
      this.$http
        .post('/api/auth/login', { email: this.email, password: this.password })
        .then((response) => {
          if (response.data.user.status === 'r') {
            window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
            this.loading = false;
            return;
          }
          this.loginSuccess(response);
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.response
            ? error.response.data.error
            : '로그인에 실패했습니다.';
        });
    },
    async loginSuccess(response) {
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);

      this.$cookies.set('token', response.data.token, 600000);
      this.$http.defaults.headers.common['Authorization'] =
        'Bearer ' + response.data.token;

      await this.$http.post('/api/auth/login/log').catch((error) => {
        console.log(error);
      });
      await this.getSettings();
      await this.goNextPage();
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.temp_login_wrap {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f5f7;
}
.temp_login_box {
  width: 340px;
  padding: 30px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}
.temp_login_title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.temp_login_input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  margin-bottom: 10px;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  background-color: #fff;
}
.temp_login_error {
  margin-bottom: 10px;
  color: #d32f2f;
  font-size: 13px;
  text-align: left;
}
.temp_login_bt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: blueviolet;
  color: #fff;
  font-weight: bold;
}
.temp_login_bt:disabled {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/TempLogin.vue